import React from 'react';
import clsx from 'clsx';
import themePrimary from '../../styles/themePrimary';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { Skin } from '../../models/common/Skin';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { String_PaymentTip_TipLabel } from '../../utilities/StringHelper';
import { UserStateContext } from '../../providers/UserStateContextProvider';

const useStyles = makeStyles({
    button: {
        height: '60px',
        width: '94%',
        marginTop: '10px',
        marginBottom: '10px',
        borderRadius: '10px',
        padding: '3px',
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: props => (props as Skin).custom_tip_button_background_color, 
        border: props => '3px solid ' + (props as Skin).custom_tip_button_background_color,      
    },
    buttonSelected: {
        height: '60px',
        width: '94%',
        marginTop: '10px',
        marginBottom: '10px',
        borderRadius: '10px',
        padding: '3px',
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: props => (props as Skin).custom_tip_button_selected_background_color, 
        border: props => '3px solid ' + (props as Skin).customTipButtonSelectedBorderColor,   
    },
    buttonTextCustomText: {
        textAlign: 'left',
        fontSize: '1.2em',
        color: props => (props as Skin).custom_tip_button_text_color,  
    },
    buttonTextCustomTextSelected: {
        textAlign: 'left',
        fontSize: '1.2em',
        color: props => (props as Skin).custom_tip_button_selected_text_color, 
    },
    buttonTextPercent: {
        textAlign: 'left',
        color: props => (props as Skin).custom_tip_button_text_color, 
    },
    buttonTextPercentSelected: {
        textAlign: 'left',
        color: props => (props as Skin).custom_tip_button_selected_text_color, 
    },
    buttonInternalContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'flex',
    },
    buttonLogoContainer: {
        float: 'right',
        textAlign: 'right',
        marginRight: '10px'
    },
    buttonTextInternalContainer: {
        float: 'left',
        textAlign: 'left',
        width: '100%',
        marginLeft: '10px'
    },
    logoImage: {
        maxHeight: '50px',
    }
});

const TipButtonInternal = withStyles((themePrimary) => ({
  root: {
    borderRadius: '50px',
    boxShadow: 'none',
    fontSize: themePrimary.typography.h4.fontSize,
    width: '100%',
    height: '100%',
  },
  label: {
      fontSize: '1rem',
  }
}))(IconButton);

export type CustomTipButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface CustomTipButtonProps {
    customText: string,
    amount: String,
    percentage: Number,
    selected :boolean
    onClickHandler: CustomTipButtonClickHandler,
}

export default function CustomTipButton(props: CustomTipButtonProps) {
    const { customText, amount, percentage, selected, onClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const userState = React.useContext(UserStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color,
        custom_tip_button_background_color: checkOutState.state.skin.custom_tip_button_background_color, 
        custom_tip_button_text_color: checkOutState.state.skin.custom_tip_button_text_color, 
        custom_tip_button_selected_background_color: checkOutState.state.skin.custom_tip_button_selected_background_color,
        custom_tip_button_selected_text_color: checkOutState.state.skin.custom_tip_button_selected_text_color,
        customTipButtonSelectedBorderColor: checkOutState.state.skin.customTipButtonSelectedBorderColor });

    return (
        <div className={clsx({
                [classes.buttonSelected]: selected,
                [classes.button]: !selected,
            })}>
            <TipButtonInternal
                onClick={onClickHandler}
                className={classes.buttonInternalContainer}>
                <div></div>

                <div className={classes.buttonTextInternalContainer}>
                    <div>
                        <span className={clsx({
                            [classes.buttonTextCustomTextSelected]: selected,
                            [classes.buttonTextCustomText]: !selected,
                        })}>{customText}</span>
                    </div>
                    <div>
                        <span className={clsx({
                            [classes.buttonTextPercentSelected]: selected,
                            [classes.buttonTextPercent]: !selected,
                        })}>{"(" + percentage.toString() + "% " + String_PaymentTip_TipLabel.find(s => s.key === userState.state.locale)!!.value + ")"}</span>
                    </div>
                </div>
                <div className={classes.buttonLogoContainer}>
                    <img src={checkOutState.state.restaurantCustomTipButtonLogoUrl!!} className={classes.logoImage}></img>
                </div>
            </TipButtonInternal>
        </div>
            
    );
}